import { gql } from '@apollo/client';

export const PERMISSIONS_HOOK_QUERY = gql`
  query Permissions {
    currentUser {
      permissions
    }
  }
`;
export const ENTITIES_BY_LIST_ID_QUERY = gql`
  query EntitiesByListIdQueryOperation($entityIds: [ID!]!) {
    entitiesByListIds(entityIds: $entityIds) {
      id
      entityType
      reputation
      reputationSources
    }
  }
`;

export const TEST_RULE_TUNING_EXPRESSION_FRAGMENT = gql`
  fragment TestRuleTuningExpressionFragment on RuleTuningExpression {
    enabled
    expression
    id
    isGlobal
    exclude
    name
  }
`;

export const LINK_RULE_TUNING_EXPRESSION_QUERY = gql`
  ${TEST_RULE_TUNING_EXPRESSION_FRAGMENT}
  query LinkRuleTuningExpressionQueryOperation($prefix: String) {
    ruleTuningExpressions(prefix: $prefix) {
      objects {
        ...TestRuleTuningExpressionFragment
      }
    }
  }
`;

export const TEST_RULE_TUNING_EXPRESSION_QUERY = gql`
  ${TEST_RULE_TUNING_EXPRESSION_FRAGMENT}
  query TestRuleTuningExpressionQueryOperation($q: String) {
    ruleTuningExpressions(q: $q) {
      objects {
        ...TestRuleTuningExpressionFragment
      }
    }
  }
`;
